const { body } = document;
const WIDTH = 580;

export default {
  data() {
    return {
      isPc: false,
      isMobile: false,
    };
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  created() {
    this.$_resizeHandler();
  },
  methods: {
    $_isMobile() {
      const rect = body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile();
        if (isMobile) {
          this.isMobile = true;
          this.isPc = false;
        } else {
          this.isMobile = false;
          this.isPc = true;
        }
      }
    },
  },
};
